import { useQueryClient } from '@tanstack/vue-query';

import {
  clearSession,
  resetAllPiniaStores,
  useUserStore,
} from '@/stores';
import { URL_PARAMS } from '@/types/enums';

export default function useLogout() {
  let queryClient: ReturnType<typeof useQueryClient> | null = null;
  try {
    queryClient = useQueryClient();
  } catch {
    /* outside Vue injection context - query cache will be cleared by page reload */
  }
  const userStore = useUserStore();

  function clearQueryCache() {
    queryClient?.clear();
  }

  async function sessionLogout(): Promise<void> {
    resetAllPiniaStores();
    return userStore.logout();
  }

  async function handleLogout({ skipClearQueryCache = false } = {}) {
    if (!skipClearQueryCache) clearQueryCache();
    resetAllPiniaStores();
    clearSessionStorage();
    clearSession();
    await sessionLogout().catch(() => {
      /* SUPPRESSION OK HERE */
    });
  }

  function clearSessionStorage() {
    sessionStorage.removeItem(URL_PARAMS.ENQUIRY_ID);
    sessionStorage.removeItem(URL_PARAMS.FROM_MSE);
    sessionStorage.removeItem(URL_PARAMS.GOAL);
  }

  return {
    handleLogout,
    sessionLogout,
    clearQueryCache,
  };
}
